"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _HR = _interopRequireDefault(require("UIComponents/elements/HR"));

var _colors = require("HubStyleTokens/colors");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  width: 28px;\n  margin: 36px 0;\n  color: ", ";\n  border-color: ", ";\n  background-color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var CalculatorDivider = (0, _styledComponents.default)(_HR.default).withConfig({
  displayName: "CalculatorDivider",
  componentId: "sc-1v9fi9n-0"
})(_templateObject(), _colors.BATTLESHIP, _colors.BATTLESHIP, _colors.BATTLESHIP);
var _default = CalculatorDivider;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/calculator/CalculatorDivider.js
// module id = 340
// module chunks = 5 6